import { render, staticRenderFns } from "./phone_guest.vue?vue&type=template&id=a96b18b2"
import script from "./phone_guest.vue?vue&type=script&lang=js"
export * from "./phone_guest.vue?vue&type=script&lang=js"
import style0 from "./phone_guest.vue?vue&type=style&index=0&id=a96b18b2&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports